import { createReducer, on } from '@ngrx/store';
import { logoutAction, userAuthedSuccessfully, userPreferencesUpdated } from './actions';
import { IUserSession } from 'src/app/core/dto';

const initialSeesions: IUserSession | null = null;

export const userSessionReducer = createReducer(
  initialSeesions,

  on(userAuthedSuccessfully, (state, { payload }) => ({
    ...payload,
  })),

  on(userPreferencesUpdated, (state, { userLanguage, userInchesUnit }) => {
    if (!state) return state;
    return {
      ...state,
      ...(userLanguage !== undefined ? { userLanguage } : {}),
      ...(userInchesUnit !== undefined ? { userInchesUnit } : {}),
    };
  }),

  on(logoutAction, (state) => null)
);
